const termsAndConditions = {
  title1: 'AVIS LEGAL',
  content1: `<v-layout row wrap>
  <v-flex xs12>
    <ol style="text-align: justify">
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>INFORMACIÓ CORPORATIVA</u>
        </li>
        <p class="body-1">
          En compliment de la Directiva, 2000/31/CE, del Parlament Europeo y del Conell de 8 de juny
          dels, Servei de la Societat de la Iinformació iComerç Electronic, y de la Llei Espanyola,
          34/2002, d’11 de juliol,
          <b>GLOSPEN, SL</b> l’informa que és titular dels llocs web:
          <b>www.fbase.tv</b>,
          d’acord amb l’exigència de l’article 10 de l’esmentada Llei,
          <b>GLOSPEN, SL</b> notifica les dades
          següents: el titular d’aquesta pàgina web és
          <b>GLOSPEN, SL</b> amb CIF/NIF:
          <b>L713690W</b> i Domicili
          Social:
          <b>CRTA DE LA PLANA, EDIF. MIRADOR PARC, BLOC- II 5º 2ª</b>, Codi Postal: AD700.
          Localitat:
          <b>ESCALDES-ENGORDANY, PRINCIPAT D&#39;ANDORRA</b>. L’adreça de correu electrònic
          de contacte amb l’empresa és:
          <b>
            <u>info@fbase.tv</u>
          </b>
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>USUARI I REGIM DE RESPONSABILITATS</u>
        </li>
        <p class="body-1">
          La navegació per accés i ús de la pàgina web i tots els subdominis i directoris inclosos sota la
          mateixa, així com els serveis o continguts que a través d&#39;ell es puguin obtenir i tots els portals
          de domini propi sota titularitat de
          <b>GLOSPEN, SL</b>, atorga la condició
          <b>d&#39;Usuari</b>, per la que
          s&#39;accepten, en navegar per la pàgina de
          <b>GLOSPEN, SL</b>, totes les condicions d&#39;ús que
          s&#39;estableixen aquí sense perjudicar l&#39;aplicació de la corresponent normativa d&#39;obligat
          compliment legal segons el cas.
        </p>
        <p class="body-1">
          Per això, si les consideracions detallades en aquest Avís Legal no són de la seva conformitat,
          preguem no faci ús del Portal, ja que qualsevol ús que faci del mateix o dels serveis i continguts
          en ell inclosos implicarà l&#39;acceptació dels termes legals recollits en aquest text.
        </p>
        <p class="body-1">
          La pàgina web de
          <b>GLOSPEN, SL</b> proporcionen gran diversitat d’informació, serveis i dades.
          <b>L’Usuari</b> assumeix la seva responsabilitat en l’ús correcte dels llocs web. Aquesta
          responsabilitat s’estendrà a: La veracitat i licitud de les informacions aportades per
          <b>l’Usuari</b> als
          formularis emesos per
          <b>GLOSPEN, SL</b> per accedir a determinats continguts o serveis oferts per
          la web.
        </p>
        <p class="body-1">
          L’ús de la informació, serveis i dades oferts per
          <b>GLOSPEN, SL</b> no aniran contra les
          disposicions d’aquestes condicions, la Llei, la moral, els bons costums o l’ordre públic o que, en
          qualsevol altre cas, puguin suposar lesió dels drets de tercers o del funcionament dels llocs
          web.
        </p>
        <p class="body-1">
          A aquest efecte,
          <b>l&#39;Usuari</b> s&#39;abstindrà d&#39;utilitzar qualsevol dels continguts amb fins o efectes
          il·lícits, prohibits en aquest text, lesius dels drets i interessos de tercers, o que de qualsevol
          forma puguin danyar, inutilitzar, sobrecarregar, deteriorar o impedir la normal utilització dels
          continguts, altres
          <b>Usuaris</b> o de qualsevol
          <b>Usuari</b> d&#39;Internet (hardware y software).
        </p>
        <p class="body-1">
          Els
          <b>Usuaris</b>
          respondran dels danys i perjudicis de tota naturalesa que l&#39;empresa propietària de
          la web pugui patir, directament o indirectament, com a conseqüència d&#39;incompliment de
          qualsevol de les obligacions derivades de l&#39;ús de la Web i d&#39;aquesta política de privacitat.
        </p>
        <p class="body-1">
          En particular, i a títol merament indicatiu i no exhaustiu,
          <b>l&#39;Usuari</b> es compromet a no
          transmetre, difondre o posar a disposició de tercers informacions, dades, continguts, missatges,
          gràfics, dibuixos, arxius de so i / o imatge, fotografies del web .
        </p>
      </div>
    </ol>
  </v-flex>
</v-layout>`,
  title2: 'POLÍTICA DE PRIVACITAT',
  content2: `<v-layout row wrap>
  <v-flex xs12>
    <ol style="text-align: justify">
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>POLÍTICA D’ENLLAÇOS I EXEMPCIONS DE RESPONSABILITAT</u>
        </li>
        <p class="body-1">
          <b>GLOSPEN, SL</b> no es fa responsable del contingut de les pàgines web a les quals pugui
          accedir
          <b>l’Usuari</b> a través dels enllaços establerts als seus llocs web i declara que en cap cas
          examinarà ni exercitarà cap tipus de control sobre el contingut d’altres pàgines de la xarxa.
        </p>
        <p class="body-1">
          Així mateix, tampoc garanteix la disponibilitat tècnica, exactitud, veracitat, validesa o legalitat de
          pàgines alienes a la seva propietat a les qual es pugui accedir a través dels enllaços.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> declara que ha adoptat totes les mesures necessàries per evitar qualsevol
          dany que pugui derivar-se de la navegació per les seves pàgines web. En conseqüència,
          <b>GLOSPEN, SL</b> no es fa responsable, en cap cas, dels eventuals danys que pugui sofrir
          <b>l’Usuari</b> a causa de la navegació per Internet.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> no es responsabilitza dels danys o perjudicis de qualsevol tipus produïts en
          <b>l&#39;Usuari</b> que portin causa d&#39;errors o desconnexions a les xarxes de telecomunicacions que
          produeixin la suspensió, cancel·lació o interrupció del servei de la web durant la prestació del
          mateix o amb caràcter previ.
        </p>
        <p class="body-1">
          L&#39;accés a la web:
          <b>
            <u>www.fbase.tv</u>
          </b> no implica l&#39;obligació per part de l&#39;empresa de controlar
          l&#39;absència de virus o qualsevol altre element informàtic danyós. Correspon a l&#39;Usuari, en tot
          cas, la disponibilitat d&#39;eines adequades per a la detecció i desinfecció de programes informàtics
          nocius.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> no es responsabilitza dels danys produïts en els equips informàtics, documents
          i/o fitxers dels Usuaris o de tercers durant la prestació del servei al Portal.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>PUBLICITAT</u>
        </li>

        <p class="body-1">
          La Web: www.fbase.tv podrà allotjar continguts publicitaris o patrocinats. Els anunciants o
          patrocinadors són els únics responsables d&#39;assegurar que el material remès per a la seva
          inclusió a la Web compleix amb les lleis que en cada cas puguin ser d&#39;aplicació.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> no serà responsable de qualsevol error, inexactitud o irregularitat que puguin
          contenir els continguts publicitaris o dels patrocinadors.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>MODIFICACIONS</u>
        </li>
        <p class="body-1">
          <b>GLOSPEN, SL</b> es reserva el dret a realitzar les modificacions que consideri oportunes, sense
          avís previ, al contingut dels seus llocs web, tant pel que fa als continguts dels llocs web com
          per les seves condicions d’ús o per les condicions generals de contractació. Aquestes
          modificacions podran realitzar-se, a través dels seus llocs web, de qualsevol forma admissible
          en dret i seran d’obligat compliment durant el temps que estiguin publicades a la web i fins que
          no siguin modificades per d’altres de posteriors.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>RESERVA DE COOKIES</u>
        </li>
        <p class="body-1">
          <b>GLOSPEN, SL</b> es reserva el dret d’utilitzar cookies en la navegació de
          <b>l’Usuari</b> pels seus llocs
          web per facilitar la personalització i comoditat de la navegació. Seguint la política de protecció
          de dades de l’empresa,
          <b>GLOSPEN, SL</b> informa que les cookies s’associen a
          <b>l’Usuari</b> anònim i
          al seu ordinador i no proporcionen per si mateixes ni el nom ni els cognoms de
          <b>l’Usuari</b>.
        </p>
        <p class="body-1">
          <b>L’Usuari</b> té la possibilitat de configurar el seu navegador de manera que sigui informat de la
          recepció de cookies, amb la possibilitat, si així ho desitja, d’impedir que s’instal·lin al seu disc
          dur. No obstant això, per accedir als llocs web de
          <b>GLOSPEN, SL</b> no és preceptiva la
          instal·lació de cookies.
        </p>
        <p class="body-1">
          <b>L&#39;Usuari</b> es compromet a abstenir-se de reproduir, copiar, distribuir, posar a disposició o de
          qualsevol altra forma de comunicar públicament, transformar o modificar els Continguts, llevat
          que es compti amb l&#39;autorització del titular dels corresponents drets o això resulti legalment
          permès.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>PROTECCIÓ DE DADES PERSONAL</u>
        </li>
        <p class="body-1">
          De conformitat amb el que estableix el Reglament General -UE- 2016/679 del Parlament i
          Consell d’Europa de Protecció de Dades de Caràcter Personal, aprovat el 27 d’abril de 2016,
          <b>GLOSPEN, SL</b> informa als
          <b>Usuaris</b> dels seus websites, que estem obligats a guardar secret
          professional de les dades personals captades per l’empresa mitjançant els formularis situats a
          les seves pàgines, aquesta obligació continurà fins i tot després d&#39;haver finalitzat la nostra
          relació comercial o contractual, i en cap cas podrem fer públics les dades personals dels
          visitants i clients a la web sense el seu consentiment, els menors de 14 anys, no poden prestar
          el seu consentiment per a què un comerç reculli i tracti les seves dades personals; solament els
          seus representants legals (pares o tutors) són els qui poden fer-ho en el seu nom. Aquells
          comerços que necessitin tractar dades de menors de 14 anys, han de disposar dels mitjans per
          obtenir el consentiment dels seus pares o tutors, per exemple, mitjançant un missatge de
          correu electrònic dirigit a algun d&#39;ells que contingui un enllaç a un formulari electrònic. No es pot
          demanar als menors de 14 anys dades sobre l&#39;àmbit familiar, sent l&#39;única excepció les dades
          d&#39;identificació i contacte dels pares o tutors.
        </p>
        <p class="body-1">
          Aquestes dades seran introduïts en un fitxer automatitzat sota la responsabilitat de
          l’administrador de la web de
          <b>GLOSPEN, SL</b>, amb la finalitat de poder facilitar, agilitzar i complir
          els compromisos establerts entre ambdues parts. Així mateix,
          <b>GLOSPEN, SL</b>, informa de la
          possibilitat d’exercir els drets
          <b>d’accés</b>, que permet a l&#39;usuari web, conèixer que dades
          personals té l&#39;administrador d&#39;aquesta pàgina i en tal cas contestés en un termini de 30 dies,
          sempre que conservi les dades,
          <b>rectificació</b>, que permet corregir errors, modificar les dades
          que siguin inexactes o incomplets i garantir la certesa de la informació,
          <b>oposició</b>, que podrà
          sol·licitar i aconseguir que no dugui a terme el tractament de dades,
          <b>supressió</b>, que permet
          que se suprimeixin les dades inadequades o excessius,
          <b>limitació</b>, pel qual pot sol·licitar que es
          limiti el tractament de les seves dades quan hagi exercit el seu dret a la rectificació de les seves
          dades personals, i
          <b>portabilitat</b>, perquè l&#39;usuari pugui obtenir una còpia de les dades personals
          que hagi facilitat a la web a fi de poder transmetre&#39;ls a altres serveis, aquests drets es podran
          exercir per qualsevol mitjà que deixi constància del seu enviament i de la seva recepció a
          l’adreça: <b>CRTA DE LA PLANA, EDIF. MIRADOR PARC, BLOC- II 5º 2ª</b>. Codi Postal:
          <b>AD700</b>. Localitat:
          <b>ESCALDES-ENGORDANY, PRINCIPAT D&#39;ANDORRA.</b>, o al correu electrònic
          <b>
            <u>info@fbase.tv</u>
          </b>,
          aportant fotocòpia del DNI o documentació alternativa que acrediti la seva identitat.
        </p>
        <p class="body-1">
          Mentre no ens comuniqui el contrari, entendrem que les seves dades no han estat modificats,
          que vostè es compromet a notificar-nos qualsevol variació i que tenim el consentiment per
          utilitzar-los a fi de poder fidelitzar la relació entre les parts.
        </p>
        <p class="body-1">
          L&#39;enviament de les seves dades mitjançant el/els formulari/s de la nostra web, estarà supeditat
          obligatòriament al fet que hagi llegit/acceptat la Política de Privacitat, mitjançant un check box
          obligatori a peu del formulari.
        </p>
        <p class="body-1">
          D’acord amb el que estableix la Llei 34/2002, de Serveis de la Societat de la Informació i el
          Comerç Electrònic en el seu article 21, demanem el seu consentiment per a poder realitzar
          comunicacions publicitàries que considerem puguin ser del seu interès, per correu electrònic o
          per qualsevol altre mitjà de comunicació electrònica equivalent, aquest consentiment ho
          acceptarà o negarà amb un check box obligatori a peu del formulari.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>PROPIETAT INTEL·LECTUAL</u>
        </li>
        <p class="body-1">
          Els drets de propietat intel·lectual i industrial derivats de tots els textos, imatges, com també
          dels mitjans i formes de presentació i muntatge de les seves pàgines pertanyen, per si
          mateixos o com a cessionària, a
          <b>GLOSPEN, SL</b> seran, per tant, obres protegides amb
          propietat intel·lectual per l’ordenament jurídic espanyol i se’ls podrà aplicar tant la normativa
          espanyola i comunitària en aquest camp, com els tractats internacionals relatius a la matèria i
          subscrits per Espanya.
        </p>
        <p class="body-1">
          Tots els drets reservats. En compliment de la Llei de la Propietat Intel·lectual es prohibeix
          expressament la reproducció, distribució, comunicació pública i utilització de la totalitat o part
          dels continguts de les seves pàgines web sense el consentiment explícit de
          <b>GLOSPEN, SL</b>
        </p>
        <p class="body-1">
          Així mateix,
          <b>GLOSPEN, SL</b> es reserva la facultat de presentar les accions civils o penals que
          consideri oportunes per la utilització indeguda de les seves pàgines web i continguts o per l’
          incompliment d’aquestes condicions.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>SEGELLS DE CONFIANÇA</u>
        </li>
        <p class="body-1">
          Els segells de confiança són distintius que es proporcionen a les tendes online per demostrar la
          seva qualitat i seguretat en la venda online.
        </p>
        <p class="body-1">
          Per aconseguir el segell, aquestes són auditades o avaluades per comprovar que compleixen
          els criteris de seguretat en la compra i compliment legal.
        </p>
        <p class="body-1">
          Les tendes que disposen d&#39;un segell de confiança estan adherides a un codi de conducta i
          solen oferir als consumidors procediments alternatius de resolució de conflictes senzills, ràpids i
          còmodes.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>CERTIFICATS DE COMPLIMENT LSSI-CE I PROTECCIÓ DE DADES</u>
        </li>
        <p class="body-1">
          <b>
            <u>www.fbase.tv</u>
          </b> compleix amb la normativa de Protecció de Dades vigent i amb la
          <b>LSSI-CE</b>, i ha
          estat assessorada en aquestes normatives per
          <b>
            <a
              target="_blank"
              href="https://www.grupoqualia.net/ca/inicio"
            >GRUPO QUALIA</a>
          </b>
          , per la qual cosa se li
          atorguen dues certificats en format d&#39;imatge digital perquè pugui exposar-los en el seu lloc web.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>ACCIONS LEGAL, LEGISLACIÓ APLICABLE I JURISDICCIÓ</u>
        </li>
        <p class="body-1">
          La relació entre l’usuari i
          <b>GLOSPEN, SL</b> es regirà per la normativa espanyola vigent i seran
          competents, per decidir sobre qualsevol controvèrsia que pugui sorgir entre l’usuari i
          <b>GLOSPEN, SL</b>, els jutjats o tribunals de la localitat de
          <b>
            ESCALDES-ENGORDANY,
            PRINCIPAT D’ANDORRA.
          </b>
        </p>
      </div>
    </ol>
  </v-flex>
</v-layout>`,
}
export default termsAndConditions
